import { render } from "./RezepteBearbeitenView.vue?vue&type=template&id=55acc633&scoped=true"
import script from "./RezepteBearbeitenView.vue?vue&type=script&lang=js"
export * from "./RezepteBearbeitenView.vue?vue&type=script&lang=js"

import "./RezepteBearbeitenView.vue?vue&type=style&index=0&id=55acc633&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55acc633"]])

export default __exports__